import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-white scroll-mt-[72px]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            内容和功能持续更新，让追剧体验越来越好
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-0 bottom-0 w-px bg-background-300"></div>

          <div className="flex flex-col gap-6 md:gap-8">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-5 pl-10 md:pl-12">
                <div
                  className={`absolute left-[11px] md:left-[15px] w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full border-2 border-white ${
                    idx < 3 ? 'bg-primary-500' : 'bg-secondary-400'
                  }`}
                ></div>

                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-colors">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-2">
                    <span className="text-xs font-label font-semibold text-primary-500 bg-primary-50 px-2.5 py-0.5 rounded-full whitespace-nowrap inline-block w-fit">
                      {item.date}
                    </span>
                    <h3 className="text-base font-heading font-bold text-foreground-950 flex-1">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-1">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}